import { Card } from '@/components/Surface'
import { PageFrame } from '@/components/PageFrame'
import { AppHeader } from '@/components/AppHeader'
import { haptic, getUserOrMock } from '@/lib/tg'
import { motion } from 'motion/react'
import { useLocation } from 'wouter'

const MENU = [
  { id: 'referrals', label: 'друзья', sub: 'приглашай — получай дни', href: '/profile/referrals' },
  { id: 'partner', label: 'партнёрство', sub: 'для блогеров и каналов', href: '/profile/partner' },
  { id: 'payments', label: 'история платежей', sub: 'все оплаты и чеки', href: '/profile/payments' },
  { id: 'settings', label: 'настройки', sub: 'язык, уведомления', href: '/profile/settings' },
  { id: 'faq', label: 'база знаний', sub: 'инструкции, типовые вопросы', href: '/profile/faq' },
  { id: 'support', label: 'поддержка', sub: 'написать админу', href: '/profile/support' },
]

export function Profile() {
  const user = getUserOrMock()
  const [, setLocation] = useLocation()

  return (
    <>
      <AppHeader />
      <PageFrame title="профиль">
        <div className="px-5 space-y-3 stagger">
          {/* Account */}
          <Card className="p-5" style={{ ['--i' as never]: 0 }}>
            <div className="text-[13px] text-[var(--color-muted)]">аккаунт</div>
            <div className="display text-[28px] mt-1.5">
              {(user.first_name + ' ' + (user.last_name ?? '')).trim().toLowerCase()}
            </div>
            <div className="num text-[12px] text-[var(--color-muted)] mt-1">id {user.id}</div>
          </Card>

          {/* Menu */}
          <div style={{ ['--i' as never]: 2 }}>
            <Card className="overflow-hidden">
              {MENU.map((m, i) => (
                <motion.button
                  key={m.id}
                  initial={{ opacity: 0, y: 4 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.18 + i * 0.04 }}
                  whileTap={{ scale: 0.992 }}
                  className="tap w-full text-left px-5 py-4 flex items-center gap-4"
                  style={{ borderBottom: i < MENU.length - 1 ? '1px solid var(--color-line)' : 'none' }}
                  onClick={() => {
                    haptic('light')
                    setLocation(m.href)
                  }}
                >
                  <div className="flex-1">
                    <div className="text-[15px] font-semibold">{m.label}</div>
                    <div className="text-[12px] text-[var(--color-muted)] mt-0.5">{m.sub}</div>
                  </div>
                  <Chevron />
                </motion.button>
              ))}
            </Card>
          </div>

          <div style={{ ['--i' as never]: 3 }} className="pt-2 text-center text-[11px] text-[var(--color-dim)]">
            цикада · v0.1
          </div>
        </div>
      </PageFrame>
    </>
  )
}

function Chevron() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-dim)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 6l6 6-6 6" />
    </svg>
  )
}
